/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Messenger API
 * API for messenger
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import moment from "moment-timezone";
import { exists, mapValues } from "../runtime";
import {
  MessengerCounselingPatient,
  MessengerCounselingPatientFromJSON,
  MessengerCounselingPatientFromJSONTyped,
  MessengerCounselingPatientToJSON,
} from "./";

export const MessengerCounselingTypename = "MessengerCounseling" as const;

/**
 *
 * @export
 * @interface MessengerCounseling
 */
export interface MessengerCounseling {
  /**
   *
   * @type {number}
   * @memberof MessengerCounseling
   */
  acceptCode?: number;
  /**
   *
   * @type {number}
   * @memberof MessengerCounseling
   */
  id: number;
  /**
   *
   * @type {boolean}
   * @memberof MessengerCounseling
   */
  isAcceptCodeVisible?: boolean;
  /**
   *
   * @type {MessengerCounselingPatient}
   * @memberof MessengerCounseling
   */
  patient: MessengerCounselingPatient;
  /**
   *
   * @type {string}
   * @memberof MessengerCounseling
   */
  requestType?: MessengerCounselingRequestTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof MessengerCounseling
   */
  requestedTime?: string;
  /**
   *
   * @type {string}
   * @memberof MessengerCounseling
   */
  type: MessengerCounselingTypeEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof MessengerCounseling
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum MessengerCounselingRequestTypeEnum {
  Web = "web",
  Line = "line",
}
/**
 * @export
 * @enum {string}
 */
export enum MessengerCounselingTypeEnum {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  FollowUpOnly = "follow_up_only",
  DeliveryOnly = "delivery_only",
  DirectVisit = "direct_visit",
}

export function MessengerCounselingFromJSON(json: any): MessengerCounseling {
  return MessengerCounselingFromJSONTyped(json, false);
}

export function MessengerCounselingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessengerCounseling {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: MessengerCounselingTypename,

    acceptCode: !exists(json, "accept_code") ? undefined : json["accept_code"],
    id: json["id"],
    isAcceptCodeVisible: !exists(json, "is_accept_code_visible") ? undefined : json["is_accept_code_visible"],
    patient: MessengerCounselingPatientFromJSON(json["patient"]),
    requestType: !exists(json, "request_type") ? undefined : json["request_type"],
    requestedTime:
      !exists(json, "requested_time") ||
      (typeof json["requested_time"] === "string" && json["requested_time"].substring(0, 4) === "0001")
        ? undefined
        : json["requested_time"],
    type: json["type"],
  };
}

export function MessengerCounselingToJSON(object?: MessengerCounseling | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code: value.acceptCode,
    id: value.id,
    is_accept_code_visible: value.isAcceptCodeVisible,
    patient: MessengerCounselingPatientToJSON(value.patient),
    request_type: value.requestType,
    requested_time:
      value.requestedTime === undefined ? undefined : moment(value.requestedTime).tz("Asia/Tokyo").format(),
    type: value.type,
  };
}
